import { OrganizationDetailTabs } from './types';

export const BASE_TAB_LIST = ['Users', 'Products'];
export const INTERCEPTOR_TAB_LIST = ['Transformations', 'External Auth'];

export const tabsConfig = [
  { label: 'Users', value: OrganizationDetailTabs.Users },
  { label: 'Products', value: OrganizationDetailTabs.Products },
  { label: 'Transformations', value: OrganizationDetailTabs.Transformations },
  { label: 'External Auth', value: OrganizationDetailTabs.ExternalAuth },
  { label: 'PA Config', value: OrganizationDetailTabs.PAConfig },
];

export const breadcrumbsNav = [
  { title: 'Tenants', link: '/organization' },
  { title: 'Tenants Details', link: '' },
];

export const a11yProps = (index: number) => ({
  id: `scrollable-auto-tab-${index}`,
  'aria-controls': `scrollable-auto-tabpanel-${index}`,
});
